import {_global} from '../utils/global-resolve';

export const convincely = _global.convincely3 || {cache: {}};
export const convincelyLegacy = _global.convincely || {};

_global.convincely3 = convincely;

/**
 * Export object to window and make it re-usable
 *
 * @param {string} name
 * @param {T} value
 * @return {T}
 * @template T
 */
export function reusable(name, value) {
  const context = convincely[name] || value;
  convincely[name] = context;

  return context;
}

/**
 * @param {string} script
 * @return {*}
 */
export function systemImport(script) {
  return System.import(script);
}
